module.exports = __webpack_public_path__ + "img/CRT_Weapon-Fan-01.294a1c04.png";